export default __webpack_public_path__ + "static/media/Medium.87762b8e.svg";